// extracted by mini-css-extract-plugin
export default {"redBorder":"SharedStyles_redBorder__dAga9","greenBorder":"SharedStyles_greenBorder__x2MIq","divInlineBlock":"SharedStyles_divInlineBlock__9ChLr"};